import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./styles.css";
import WalletProvider from "./providers/WalletProvider";
import HomePage from "./App";
import PricePrediction from "./priceprediction";
import FutureMarket from "./futuremarket";
import FutureTrading from "./pages/FutureTrading";
import AllMarkets from "./allmarket";
import MarketDetail from "./price";
import UserDashboard from "./pages/UserDashboard";
import CoinMarketInfo from "./pages/CoinMarketInfo";
import PublicAPI from "./pages/PublicAPI";
import Fees from "./pages/Fees";
import CreateMarket from "./pages/CreateMarket";
import ContractSpecification from "./pages/ContractSpecification";
import SocialShare from "./pages/SocialShare";
import Leaderboard from "./pages/Leaderboard";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <WalletProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/price-prediction" element={<PricePrediction />} />
            <Route path="/future-trading" element={<FutureTrading />} />
            <Route path="/markets" element={<AllMarkets />} />
            <Route path="/market/:slug" element={<MarketDetail />} />
            <Route path="/user-dashboard" element={<UserDashboard />} />
            <Route path="/coin-market-info" element={<CoinMarketInfo />} />
            <Route path="/public-api" element={<PublicAPI />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/create-market" element={<CreateMarket />} />
            <Route path="/contract-specification" element={<ContractSpecification />} />
            <Route path="/share/:platform" element={<SocialShare />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
          </Routes>
        </BrowserRouter>
      </WalletProvider>
    </HelmetProvider>
  </React.StrictMode>
);
